import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import FilterList from '../icons/material-symbols/filterList';
import { DEVICE_SIZE, mq } from '../utils/mq';

const Wrapper = styled.div`
  font-size: 18px;
  font-weight: 400;
  font-family: var(--theme-typography-primary-font);

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      font-size: 16px;
    `,
  )}
`;
const Select = styled.div`
  border: none;
  text-decoration: underline;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: var(--spacer-xs);
`;

const DropDown = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  color: var(--theme-color-foreground);
  border: 1px solid var(--color-alt-2);
  border-radius: 4px;
  background-color: var(--theme-color-background);
  position: absolute;
  min-width: 250px;
  z-index: 100;
`;

const Option = styled.li`
  padding: var(--spacer-xs);
  cursor: pointer;
  :hover {
    background-color: var(--color-alt-2);
  }
`;

type OptionType = {
  key: string;
  value: string;
};
type Props = {
  options: OptionType[];
  onChange: (o: string) => void;
  value: string;
};
const CustomSelectOrder = ({ options, onChange, value }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    options.reduce((acc: string, v) => (v.key === value ? v.value : acc), ''),
  );

  const handleOptionClick = useCallback(
    (option: OptionType) => {
      setSelectedOption(option.value);
      setIsOpen(false);
      if (onChange) {
        onChange(option.key);
      }
    },
    [onChange],
  );

  return (
    <Wrapper data-testid="custom-select-order">
      <Select onClick={() => setIsOpen((prev) => !prev)}>
        <span>{selectedOption}</span>
        <FilterList width={18} height={18} color="var(--theme-color-foreground)" />
      </Select>
      {isOpen && (
        <DropDown>
          {options.map((option) => (
            <Option
              key={option.key}
              onClick={() => handleOptionClick(option)}
              className={value === option.key ? 'selected' : null}
            >
              {option.value}
            </Option>
          ))}
        </DropDown>
      )}
    </Wrapper>
  );
};

export default CustomSelectOrder;
